// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11 2H2V11H11V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 2H13V11H22V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M11 13H2V22H11V13Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M18.5 12.9999H16.5V16.5H13V18.5H16.5V22H18.5V18.5H22V16.5H18.5V12.9999Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-grid-add-filled')
export default class GridAddFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'grid-add-filled',
    }
  }
}
